export default "__VITE_ASSET__BKDLcIJO__"